<template>
  <aha-modal
    @hide="$emit('hide')"
    :title="$i18nPresenter.t('Share Report')"
  >
    <p class="mb-4" v-html="$i18nPresenter.t('share_report_modal_content_1')" />
    <p v-html="$i18nPresenter.t('share_report_modal_content_2')" />
    <template #action>
      <aha-antd-button
        variant="secondary"
        @click="$emit('hide')"
      >
        {{ $i18nPresenter.t('Got it') }}
      </aha-antd-button>
    </template>
  </aha-modal>
</template>
<script>

export default {}
</script>
